import React, {useState} from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {map} from 'lodash';
import Button from 'src/components/button';
import Icon from 'shared/components/icon';
import classnames from 'classnames';
import {NavbarButtonProps} from '../NavbarButton';
import NavbarLink from '../NavbarLink/NavbarLink';
import styles from './styles.module.scss';

export interface NavbarMenuProps {
  title: string;
  routed?: boolean;
  isActiveLink?: boolean;
  menuItems?: NavbarButtonProps[];
  // TODO: used in files that import this type
  /* eslint-disable react/no-unused-prop-types */
  path?: string;
  newTab?: boolean;
  iconType?: string;
  /* eslint-enable react/no-unused-prop-types */
}

const NavbarMenu = (props: NavbarMenuProps) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClose = (): void => {
    setAnchorEl(null);
  };

  const handleClick = (event): void => {
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }
  };

  const menuItemsRoutedFalse = (): NavbarButtonProps[] =>
    (props?.menuItems || []).map(({path, title}) => ({
      path,
      title,
      routed: false,
    }));

  const menuListItems = props.routed ? props.menuItems : menuItemsRoutedFalse();

  const selected = !!anchorEl;

  return (
    <>
      <Button
        onClick={handleClick}
        link
        color="gray"
        size="small"
        className={classnames(styles.navBarButton, {[styles.active]: selected})}
        margin={false}
        disablePath
      >
        {props.isActiveLink && <div className={styles.activeLink} data-testid="active-indicator" />}
        <span data-testid="navbar-link">
          {props.title}
          <Icon
            iconType="chevron-down"
            className={classnames(styles.icon, {[styles.rotate]: selected})}
          />
        </span>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
        transformOrigin={{vertical: 'top', horizontal: 'left'}}
        transitionDuration={300}
        keepMounted
        elevation={1}
        PopoverClasses={{
          paper: styles.popover,
        }}
      >
        {map(menuListItems, (item) =>
          item.disabled ? (
            <div key={item.title} className={styles.itemTitle}>
              {item.title}
            </div>
          ) : (
            <MenuItem
              key={item.path || item.title}
              aria-label={item.title}
              onClick={handleMenuClose}
              classes={{
                root: styles.menuItem,
              }}
              disableRipple
            >
              <NavbarLink to={item.path} title={item.title} routed={item.routed} />
            </MenuItem>
          )
        )}
      </Menu>
    </>
  );
};

export default NavbarMenu;
